import { render, staticRenderFns } from "./SelectTree.vue?vue&type=template&id=2af084c3&scoped=true"
import script from "./SelectTree.vue?vue&type=script&lang=js"
export * from "./SelectTree.vue?vue&type=script&lang=js"
import style0 from "./SelectTree.vue?vue&type=style&index=0&id=2af084c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af084c3",
  null
  
)

export default component.exports